exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section[data-v-c144ea64]{-webkit-box-shadow:rgba(17,17,26,0.05) 0 1px 0,rgba(17,17,26,0.1) 0 0 8px;box-shadow:rgba(17,17,26,0.05) 0 1px 0,rgba(17,17,26,0.1) 0 0 8px}.section[data-v-c144ea64]:hover{-webkit-box-shadow:rgba(17,17,26,0.1) 0 0 16px;box-shadow:rgba(17,17,26,0.1) 0 0 16px}\n", ""]);

// exports
